import type { Notification } from "@circle-react/types/Notification";

import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

export interface DisplayActionProps {
  notification: Notification;
}

export const DisplayAction = ({ notification }: DisplayActionProps) => (
  <Typography.BodySm as="span">{notification.display_action}</Typography.BodySm>
);
